import type { CommuteMethod } from '../types';

export const mapCommuteMethodToLabelText = (commuteMethod: CommuteMethod): string => {
  switch (commuteMethod) {
    case 'walking':
      return 'Walking';
    case 'cycling':
      return 'Bicycle';
    case 'public_transport':
      return 'Public Transport';
    case 'driving':
      return 'Car';
  }
};
